import { render } from "./ProcessList.vue?vue&type=template&id=25dc33f6"
import script from "@/assets/projectJs/ProcessList.js?vue&type=script&lang=js"
export * from "@/assets/projectJs/ProcessList.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__